import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { MessageComponent } from './components/message/message.component';
import { ModalComponent } from './components/modal/modal.component';
import { PopupComponent } from './components/popup/popup.component';
import { HorizontalDragDirective } from './directives/horizontal-drag.directive';
import { MessageService } from './services/message.service';
import { DocumentService } from './services/document.service';
import { CommonModule } from '@angular/common';
import { SecondsPipe } from './pipes/seconds.pipe';
import { HeaderComponent } from './components/header/header.component';
import { RouterModule } from '@angular/router';
import { MetaComponent } from './components/meta/meta.component';
import { ApiService } from './services/api.service';

@NgModule({
  imports: [
    FormsModule,
    HttpClientModule,
    CommonModule,
    RouterModule,
  ],
  providers: [
    DocumentService,
    MessageService,
    ApiService,
  ],
  declarations: [
    HorizontalDragDirective,
    PopupComponent,
    ModalComponent,
    MessageComponent,
    SecondsPipe,
    HeaderComponent,
    MetaComponent,
  ],
  exports: [
    FormsModule,
    HttpClientModule,
    CommonModule,
    HorizontalDragDirective,
    PopupComponent,
    ModalComponent,
    MessageComponent,
    SecondsPipe,
    HeaderComponent,
    MetaComponent,
  ]
})
export class SharedModule {
}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts